<template>
  <div :class="{ opening: opening, closing: closing }" class="cookies">
    <div class="container">
      <div class="title">Cookies</div>
      <div class="description">
        Utilizamos cookies propias y de terceros para analizar sus hábitos de
        navegación, obtener información estadística, mostrarte publicidad
        relacionada con esos hábitos de navegación e interactuar con redes
        sociales. Más información, en nuestra <a href="#/politica-cookies">Política de cookies</a>.
      </div>
      <div v-if="!configureInfo" class="buttons">
        <div>
          <div class="button-cookies accept" @click="accept()">Aceptar</div>
          <div class="button-cookies decline" @click="decline()">
            No aceptar
          </div>
        </div>
        <div>
          <div class="button-cookies configure" @click="configure()">
            Configurar las cookies
          </div>
        </div>
      </div>
      <div v-if="configureInfo" class="configure">
        <div>
          <i class="fad fa-check-square text-gris fs-18 mr-10 bg-gris-claro cursor-pointer"></i>
          <span><strong>Necesarias</strong> Las cookies necesarias ayudan a hacer una página web utilizable activando funciones básicas como la navegación en la página y el acceso a áreas seguras de la página web. La página web no puede funcionar adecuadamente sin estas cookies.</span>
        </div>
        <div>
          <i :class="{'fas fa-square text-gris-claro': !checkedAnaliticas, 'fad fa-check-square text-gris': checkedAnaliticas}" class="fs-18 mr-10 bg-gris-claro cursor-pointer" @click="checkInput('analiticas')"></i>
          <span><strong>Analíticas (opcional)</strong> Las cookies analíticas ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas web reuniendo y proporcionando información de forma anónima.</span>
        </div>
        <div>
          <i :class="{'fas fa-square text-gris-claro': !checkedPublicitarias, 'fad fa-check-square text-gris': checkedPublicitarias}" class="fs-18 mr-10 bg-gris-claro cursor-pointer" @click="checkInput('publicitarias')"></i>
          <span><strong>Publicitarias (opcional)</strong> Las cookies publicitarias se utilizan para rastrear a los visitantes en las páginas web. La intención es mostrar anuncios relevantes y atractivos para el usuario individual, y por lo tanto, más valiosos para los editores y terceros anunciantes.</span>
        </div>
      </div>
      <div v-if="configureInfo" class="buttons">
        <div>
          <div class="button-cookies accept" @click="accept()">Aceptar todo</div>
          <div class="button-cookies decline" @click="acceptOnly()">
            Aceptar configuración actual
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Cookies',
  data: () => ({
    opening: false,
    closing: false,
    configureInfo: false,
    checkedAnaliticas: false,
    checkedPublicitarias: false
  }),
  created () {
    if (this.checkCookies() === null) {
      this.opening = true
    }

    if (this.checkCookies() !== null) {
      const parts = this.checkCookies().split(`.`)
      if (Number(parts[1]) === 1) {
        this.checkedAnaliticas = true
      }

      if (Number(parts[2]) === 1) {
        this.checkedPublicitarias = true
      }

      if (Number(parts[0]) === 1) {
        this.setCookie(true)
      }

      if (Number(parts[0]) === 0) {
        this.setCookie(false)
      }
    }
  },
  methods: {
    checkInput (tipo) {
      if (tipo === 'analiticas') {
        this.checkedAnaliticas = !this.checkedAnaliticas
      }
      if (tipo === 'publicitarias') {
        this.checkedPublicitarias = !this.checkedPublicitarias
      }
    },
    checkCookies () {
      var name = 'socialdoctor_cookie='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return null
    },
    setCookie (cvalue, ctype = '') {
      let remain = 7
      let valueC = '0'
      if (cvalue === true) {
        remain = 365
        valueC = '1'
      }

      let valueA = '.0'
      if (cvalue === true && (ctype === 'all' || this.checkedAnaliticas)) {
        valueA = '.1'
        // GOOGLE ANALYTICS
        let gaC = document.createElement('script')
        gaC.type = 'text/javascript'
        gaC.innerHTML = `
        var _gaq = _gaq || []
        _gaq.push(['_setAccount', '${this.$store.state.gaCode}'])
        _gaq.push(['_trackPageview'])
        `
        let sC = document.getElementsByTagName('script')[0]
        sC.parentNode.insertBefore(gaC, sC)

        // eslint-disable-next-line no-unused-vars
        let ga = document.createElement('script')
        ga.type = 'text/javascript'
        ga.async = true
        ga.src = (document.location.protocol === 'https:' ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'
        let s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(ga, s)

        // PIXEL GOOGLE ADS
        let gaP = document.createElement('script')
        gaP.type = 'text/javascript'
        gaP.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${this.$store.state.pxCode}');
        `
        let sP = document.getElementsByTagName('script')[0]
        sP.parentNode.insertBefore(gaP, sP)

        // eslint-disable-next-line no-unused-vars
        let gp = document.createElement('script')
        gp.type = 'text/javascript'
        gp.async = true
        gp.src = `https://www.googletagmanager.com/gtag/js?id=${this.$store.state.pxCode}`
        let p = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(gp, p)

        // PIXEL FACEBOOK
        let gaF = document.createElement('script')
        gaF.type = 'text/javascript'
        gaF.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${this.$store.state.fbCode}');  
        fbq('track', 'PageView');
        `
        let sF = document.getElementsByTagName('script')[0]
        sF.parentNode.insertBefore(gaF, sF)

        // eslint-disable-next-line no-unused-vars
        let fb = document.createElement('noscript')
        fb.innerHTML = `
        <img height="1" width="1" src="https://www.facebook.com/tr?id=${this.$store.state.fbCode}&ev=PageView&noscript=1"/>
        `
        let f = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(fb, f)
      }

      let valueP = '.0'
      if (cvalue === true && (ctype === 'all' || this.checkedPublicitarias)) {
        valueP = '.1'
        // INCLUDE PIXEL FACEBOOK, etc.
      }

      var d = new Date()
      d.setTime(d.getTime() + (remain * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = `socialdoctor_cookie=${valueC}${valueA}${valueP};${expires};path=/`
    },
    accept () {
      this.setCookie(true, 'all')
      this.closing = true
    },
    acceptOnly () {
      if (!this.checkedAnaliticas || !this.checkedPublicitarias) {
        this.setCookie(false)
      }
      if (this.checkedAnaliticas || this.checkedPublicitarias) {
        this.setCookie(true)
      }
      this.closing = true
    },
    decline () {
      this.setCookie(false)
      this.closing = true
    },
    configure () {
      this.configureInfo = true
    }
  }
}
</script>

<style lang="scss" scoped>
.cookies {
  position: fixed;
  width: calc(100% - 9px);
  max-height: 100%;
  overflow-y: auto;
  left: 0;
  bottom: -120%;
  padding-top: 35px;
  padding-bottom: 35px;
  background: #fff;
  text-align: left;
  z-index: 1;
  box-shadow: 0px -4px 40px rgba(0, 0, 0, 0.25);
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
      background-color: #dfe6e9;
      border-radius: 9px;
      cursor: pointer;
      overflow: hidden;
      width: 9px;
  }

  &::-webkit-scrollbar-thumb {
      background-color: #95a5a6;
      border-radius: 9px;
  }

  &::-webkit-scrollbar-track {
      background-color: #dfe6e9;
      opacity: 0;
  }

  &.opening {
    animation: showCookies 1s 1s ease-in forwards;
  }

  &.closing {
    bottom: 0%;
    animation: hideCookies 1s 0s ease-in forwards;
  }

  @keyframes showCookies {
    from {
      bottom: -120%;
    }
    to {
      bottom: 0%;
    }
  }

  @keyframes hideCookies {
    from {
      bottom: 0%;
    }
    to {
      bottom: -120%;
    }
  }

  .title {
    font-weight: 600;
    font-size: 36px;
    color: #444d67;
    margin-bottom: 20px;
  }

  .description {
    font-size: 16px;
    line-height: 19px;
    letter-spacing: -0.4px;
    color: rgba(97, 97, 97, 0.79);
    margin-bottom: 20px;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    > div {
      display: flex;
    }

    .button-cookies {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      padding-left: 20px;
      padding-right: 20px;
      border-radius: 8px;
      cursor: pointer;

      &.accept {
        background: #4ac4d0;
        color: #fff;
        border: 1px solid #4ac4d0;
        margin-right: 30px;
      }

      &.decline {
        background: #f7f7f7;
        color: #c1c1c1;
        border: 1px solid #c1c1c1;
      }

      &.configure {
        background: rgba(74, 196, 208, 0.2);
        color: #4ac4d0;
        border: 1px solid #4ac4d0;
      }
    }
  }

  .configure {
    border: 1px solid #f3f3f3;
    border-radius: 5px;
    padding: 30px;

    div {
      display: flex;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 15px;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: -0.4px;
      color: rgba(97, 97, 97, 0.79);

      i {
        margin-right: 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media(max-width: 990px) {
  .cookies {
    padding-top: 0;
    padding-bottom: 0;

    .container {
      padding: 30px;

      .title {
        font-size: 28px;
      }

      .description {
        font-size: 14px;
      }

      .buttons .button-cookies {
        height: 40px;
        font-size: 16px;
        padding-left: 15px;
        padding-right: 15px;

        &.accept {
          margin-right: 15px;
        }
      }

      .configure {
        padding: 20px;
        font-size: 14px;
      }
    }
  }
}

@media(max-width: 580px) {
  .cookies .container .buttons {
    flex-direction: column;
    align-items: flex-start;

    > div {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
    }

    .button-cookies {
      width: 100%;
      margin-right: 0;
      margin-bottom: 15px;
      font-size: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cookies.vue